import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, type Observable } from 'rxjs';
import type { MultiItemResponse } from '../models/middleware/multi-item-response.model';
import type { UpdateItemModel } from '../models/middleware/update-item.model';
import type { UpdateItem } from '../models/update-item.model';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  private readonly http = inject(HttpClient);
  private readonly url = `/api/authenticated/event/updates`;

  getEventUpdates(eventId: string, highPriorityOnly = false): Observable<UpdateItem[]> {
    let params = {};
    if (highPriorityOnly) {
      params = { params: new HttpParams().set('priority', 'high') };
    }

    return this.http
      .get<MultiItemResponse<UpdateItemModel>>(`${this.url}/${eventId}`, params)
      .pipe(map((response) => response.items.map((update) => this.convertToDisplayItem(update))));
  }

  private convertToDisplayItem(apiItem: UpdateItemModel): UpdateItem {
    return {
      id: apiItem.id.toString(),
      title: apiItem.title,
      description: apiItem.description,
      priority: apiItem.priority,
      publishedAt: new Date(apiItem.createdAt),
    };
  }
}
